import 'jquery.cookie'
export default function (opt) {
    if (typeof opt == 'undefined') {
        opt = {};
    }
    if (!opt.siteName) {
        opt.siteName = '';
    }

    var config = jQuery.extend({
        siteName: '',
        emptyCSS: false,
        html: '',
        buttonText: 'Accepteer',
        content: opt.siteName + ' maakt gebruik van <a style="text-decoration: underline; color: white;" href="/cookiebeleid/">cookies</a> om de website goed te laten functioneren. Als je onze website gebruikt, gaan wij ervan uit dat je daarvoor toestemming geeft.'
    }, typeof opt === 'object' ? opt : {});

    var html = '<div class="cookie-bar" style="position: fixed; bottom: 0px; width: 100%; padding: 15px 0px; background: rgba(0,0,0,0.8); z-index: 999999">' +
        '<div class="cookie-bar-wrapper" style="margin: 0px auto; max-width: 1000px; padding: 0px 15px;">' +
        '<div class="cookie-bar-left" style="float: left; width: 70%; color: white; font-size: 13px; line-height: 1.3; padding-right: 30px;">' +
        config.content +
        '</div>' +
        '<div class="cookie-bar-right" style="float: right; width: 30%;">' +
        '<a class="btn" style="background-color: #000000; text-transform: uppercase; border: 1px solid black; padding: 5px 15px; border-radius: 2px; color: white; font-size: 13px; line-height: 2.3; width: 100%; display: inline-block; text-align: center; margin-top: 10px;" href="#">' + config.buttonText + '</a>' +
        '</div>' +
        '<div class="clear_div" style="clear: both; line-height: 1px;"></div>' +
        '</div><style>div.cookie-bar-wrapper * { box-sizing: border-box; } div.cookie-bar-wrapper a.btn:hover { background-color: white !important; color: black !important; }</style>' +
        '</div>';
    if (config.emptyCSS === true) {
        html = '<div class="cookie-bar">' +
            '<div class="cookie-bar-wrapper">' +
            '<div class="cookie-bar-left">' +
            config.content +
            '</div>' +
            '<div class="cookie-bar-right">' +
            '<a class="btn" href="#">' + config.buttonText + '</a>' +
            '</div>' +
            '<div class="clear_div"></div>' +
            '</div>' +
            '</div>';
    }
    if (config.html != "") {
        html = config.html;
    }

    try {
        if (typeof jQuery.cookie('cookies-accepted') === 'undefined') {
            jQuery('body').append(html);
            jQuery('.cookie-bar a.btn, div#cookie-notice a#cn-accept-cookie').click(function () {
                jQuery.cookie('cookies-accepted', '1', {expires: 365, path: '/'});
                jQuery('.cookie-bar').hide();
                jQuery('div#cookie-notice').hide();
                return false;
            });
        }
    } catch (error) {
        console.log(error);
        console.log('Unable to find the cookie lib.');
    }
};